import React, { forwardRef } from 'react';
import DatePicker from "react-datepicker";
import { Controller } from "react-hook-form";
import FormControl from "./FormControl";
import FormDateTimeZone from "./FormDateTimeZone";

import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";

const getOnChangeValue = (date, isStartOfDay, isEndOfDay) => (date && ((isStartOfDay && startOfDay(date)) || (isEndOfDay && endOfDay(date)) || date))

const CustomDateInput = forwardRef((props, ref) => <FormDateTimeZone forwardedRef={ref} {...props} />);

const FormDatePicker = (props) => {
    const {
        labelText,
        validations,
        startDate,
        endDate,
        selectRange,
        id,
        isStartOfDay,
        isEndOfDay,
        ...rest } = props;

    return (
        <FormControl
            labelText={labelText}
            render={({ inputClass }) =>
                <Controller
                    {...rest}
                    rules={validations}
                    render={({ field }) => (
                        <DatePicker
                            {...rest}
                            selected={field.value}
                            customInput={
                                <CustomDateInput
                                    className={inputClass}
                                    dateValue={field.value}
                                />}
                            onChange={(date) => field.onChange(getOnChangeValue(date, isStartOfDay, isEndOfDay))}
                            startDate={startDate}
                            endDate={endDate}
                        />
                    )}
                />
            }
            {...rest}
        />
    );
}

export default FormDatePicker;